/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from 'react';

import { withStyles } from '@material-ui/core/styles'

import { Popper, Paper, Typography, ClickAwayListener, FormControl, Select, MenuItem, InputLabel, FormHelperText, IconButton, Divider } from '@material-ui/core'

import { Clear } from '@material-ui/icons'

import DayRangePicker from './components/PickerComponents/DayRangePicker'
import MonthRangePicker from './components/PickerComponents/MonthRangePicker'
import WeekRangePicker from './components/PickerComponents/WeekRangePicker';
import QuarterRangePicker from './components/PickerComponents/QuarterRangePicker'
import HalfYearRangePicker from './components/PickerComponents/HalfYearRangePicker';
import YearRangePicker from './components/PickerComponents/YearRangePicker';

const styles = theme => ({

})

class MultiPicker extends Component {
    state = {}


    renderDatePickers = () => {
        if (this.props.filter.resolution === 'Daily') {
            return (
                <div style = {{width : '100%', padding : '10px', backgroundColor : '#F0F0F0'}}>
                    <DayRangePicker update_filter = {(filter, value) => this.props.update_filter(filter, value)} filter = {this.props.filter}/>
                </div>
            )
        } else if (this.props.filter.resolution === 'Weekly') {
            return (
                <div style = {{width : '100%', padding : '10px', backgroundColor : '#F0F0F0'}}>
                    <WeekRangePicker update_filter = {(filter, value) => this.props.update_filter(filter, value)} filter = {this.props.filter}/>
                </div>
            )
        } else if (this.props.filter.resolution === 'Monthly') {
            return (
                <div style = {{width : '100%', padding : '10px', backgroundColor : '#F0F0F0'}}>
                    <MonthRangePicker update_filter = {(filter, value) => this.props.update_filter(filter, value)} filter = {this.props.filter}/>
                </div>
            )
        } else if (this.props.filter.resolution === 'Quarterly') {
            return (
                <div style = {{width : '100%', padding : '10px', backgroundColor : '#F0F0F0'}}>
                    <QuarterRangePicker update_filter = {(filter, value) => this.props.update_filter(filter, value)} filter = {this.props.filter}/>
                </div>
            )
        } else if (this.props.filter.resolution === 'Half_Yearly') {
            return (
                <div style = {{width : '100%', padding : '10px', backgroundColor : '#F0F0F0'}}>
                    <HalfYearRangePicker update_filter = {(filter, value) => this.props.update_filter(filter, value)} filter = {this.props.filter}/>
                </div>
            )
        } else if (this.props.filter.resolution === 'Yearly') {
            return (
                <div style = {{width : '100%', padding : '10px', backgroundColor : '#F0F0F0'}}>
                    <YearRangePicker update_filter = {(filter, value) => this.props.update_filter(filter, value)} filter = {this.props.filter}/>
                </div>
            )
        }
    }

    renderResolutionPicker = () => {
        return (
            <Fragment>
                <div style = {{padding : '10px'}}>
                    <FormControl>
                        <InputLabel>Resolution</InputLabel>
                        <Select
                            value = {this.props.filter.resolution}
                            onChange = {(event) => this.props.update_filter("resolution", event.target.value)}
                        >
                            <MenuItem value = "Daily">Daily</MenuItem>
                            <MenuItem value = "Weekly" >Weekly</MenuItem>
                            <MenuItem value = "Monthly">Monthly</MenuItem>
                            <MenuItem value = "Quarterly">Quarterly</MenuItem>
                            {/* <MenuItem value = "Half_Yearly">Half Yearly</MenuItem> */}
                            <MenuItem value = "Yearly">Yearly</MenuItem>
                        </Select>
                        <FormHelperText>Choose the resolution for analytics.</FormHelperText>
                    </FormControl>
                </div>
                <Divider style = {{marginTop : '5px'}}/>
            </Fragment>
        )
    }

    render() {
        return (
            <Popper open = {this.props.open} anchorEl = {this.props.anchorEl} placement = 'bottom-start'>
                <Paper square elevation = {4} style = {{minWidth : this.props.width + 'px'}}>
                    <div style = {{width : '100%', height : '50px', display : 'flex', flexDirection : 'row', alignItems : 'center', padding : '10px', borderBottom : '1px solid rgba(0,0,0,0.12)'}}>
                        <Typography style = {{flexGrow : 1, fontWeight : 800}} variant = 'h6'>Configure Filter</Typography>
                        <IconButton color = 'secondary' size = 'small' onClick = {this.props.handleClose}>
                            <Clear fontSize = 'small'/>
                        </IconButton>
                    </div>
                    {this.renderResolutionPicker()}
                    {this.renderDatePickers()}
                </Paper>
            </Popper>
        );
    }
}

export default MultiPicker;